{
  "general": {
    "cancel": "Tühista",
    "delete": "Kustuta",
    "no": "Ei",
    "ok": "Ok",
    "yes": "Jah",
    "selectGender": "Vali sugu",
    "gender": {
      "male": "Mees",
      "female": "Naine"
    }
  },
  "menu": {
    "categories": "Kategooriad",
    "departments": "Osakonnad",
    "home": "Avaleht",
    "procedures": "Protseduurid",
    "manageProcedures": "Halda protseduure",
    "manageCategories": "Halda kategooriaid",
    "scheduling": "Kalender",
    "users": "Kasutajad"
  },
  "device": {
    "udi": "UDI"
  },
  "procedures": {
    "addProcedure": "Lisa protseduur",
    "deleteProcedure": "Kustuta protseduur",
    "searchProcedures": "Otsi protseduure"
  },
  "approvalRequest": {
    "actionType": "Toimingu tüüp",
    "requestedBy": "Taotleja",
    "approvedBy": "Kinnitaja",
    "confirms": {
      "approveTitle": "Kinnita taotlus",
      "approveText": "Kas oled kindel, et soovid selle taotluse kinnitada?",
      "rejectTitle": "Lükka taotlus tagasi",
      "rejectText": "Palun esita põhjus selle taotluse tagasilükkamiseks.",
      "rejectReasonPlaceholder": "Tagasilükkamise põhjus"
    },
    "actionTypes": {
      "PERMISSION_GRANT": "Õiguse andmine",
      "PERMISSION_REVOKE": "Õiguse tühistamine",
      "EXPORT_VISITS": "Visiitide eksport",
      "EXPORT_LOCATION_HISTORY": "Asukohajaloo eksport",
      "EXPORT_ARRIVAL_HISTORY": "Saabumisajaloo eksport",
      "ENABLE_USER": "Aktiveeri kasutaja",
      "DISABLE_USER": "Deaktiveeri kasutaja"
    },
    "toasts": {
      "created": "Kinnituse taotlus loodud",
      "applied": "Toiming rakendatud",
      "applyFailed": "Toimingu rakendamine ebaõnnestus",
      "approved": "Taotlus kinnitatud",
      "approveFailed": "Taotluse kinnitamine ebaõnnestus",
      "rejected": "Taotlus tagasi lükatud",
      "rejectFailed": "Taotluse tagasilükkamine ebaõnnestus"
    }
  },
  "step": {
    "transitionToNextStep": "Üleminek järgmisele sammule",
    "transitionType": "Ülemineku tüüp",
    "parentStep": "Eelnev samm",
    "previousStep": "Eelmine samm",
    "option": "Valik",
    "editStep": "Muuda sammu",
    "description": "Kirjeldus",
    "addNewStep": "Lisa uus samm",
    "owner": "Omanik",
    "viewInProcedure": "Vaata protseduuris",
    "stepMedia": "Sammu meedia",
    "saveMedia": "Salvesta",
    "dropFilesOrClickToUpload": "Lohista failid siia või kliki üleslaadimiseks",
    "addDescription": "Lisa kirjeldus",
    "chooseType": "Vali tüüp",
    "insertOption": "Sisesta valik",
    "insertMinValue": "Sisesta MIN väärtus",
    "insertMaxValue": "Sisesta MAX väärtus",
    "chooseTransitionType": "Vali ülemineku tüüp",
    "chooseParentSep": "Vali eelnev samm",
    "chooseStepOption": "Vali sammu valik",
    "addParentStep": "Lisa eelnev samm",
    "type": "Tüüp",
    "value": "Väärtus",
    "error": {
      "WONT_REACH_END": "Puudub tee LÕPUNI",
      "EXIT_NOT_IN_USE": "Kasutamata väljund",
      "NO_PARENT_SET": "Puudub eelnev samm",
      "PARENT_NOT_EXITS": "Määratud eelmine samm ei eksisteeri",
      "DUPLICATE_START": "Protseduuril saab olla ainult üks ALGUSE samm",
      "DUPLICATE_END": "Protseduuril saab olla ainult üks LÕPU samm",
      "NO_START": "Protseduuril puudub ALGUSE samm",
      "NO_END": "Protseduuril puudub LÕPU samm",
      "MULTIPLE_CHILDREN_FOR_EXIT": "Väljundit kasutab rohkem kui üks samm"
    }
  },
  "patients": {
    "standingAssignment": "Alaline määramine",
    "noStandingAssignment": "Alaline määramine puudub",
    "unknownNurse": "Määratud õde (nimi ei ole saadaval)",
    "standingAssignmentHelperText": "Alalise määramisena saab valida ainult koduõe (Home Nurse) rolliga kasutajaid.",
    "changeStandingAssignment": "Muuda määramist",
    "clearStandingAssignment": "Eemalda määramine",
    "confirmClearStandingAssignmentText": "Kas soovite kindlasti selle patsiendi alalise määramise eemaldada?",
    "standingAssignmentLabel": "{name} (alaline)",
    "onShiftLabel": "{name} (vahetuses)",
    "currentlyOnShiftWith": "Praegu vahetuses koos",
    "notCurrentlyOnShift": "Praegu vahetuses ei ole",
    "visitName": "Nimi",
    "visitDate": "Kuupäev",
    "performedBy": "Teostaja",
    "status": "Staatus",
    "location": "Asukoht / palat (valikuline)",
    "enterLocation": "Sisestage asukoht või palati number",
    "admissionDate": "Vastuvõtu kuupäev (valikuline)",
    "dischargeDate": "Väljakirjutamise kuupäev (valikuline)",
    "acuity": "Raskusaste (valikuline)",
    "unsupportedFieldsNotice": "Allergia, ravimid, pikkus, kaal, patsiendi tüüp ning seisundi kood/nimi ei ole selle importimisega toetatud – lisage need pärast importimist käsitsi.",
    "import": {
      "importSucceeded": "{created} patsienti imporditud, {duplicates} duplikaati vahele jäetud.",
      "departmentsLoadFailed": "Osakondade laadimine ebaõnnestus. Palun proovige uuesti."
    }
  },
  "errors": {
    "UNKNOWN_ERROR": "Tundmatu viga"
  },
  "titles": {
    "categories": "Kategooriad",
    "visitreport": "Visiidi aruanne"
  },
  "toasts": {
    "patientAdded": "Patsient lisati edukalt",
    "patientUpdated": "Patsiendi andmed uuendati edukalt",
    "procedureAdded": "Protseduur lisati edukalt",
    "procedureUpdated": "Protseduur uuendati edukalt",
    "procedureDeleted": "Protseduur kustutati edukalt",
    "visitAdded": "Visiit lisati edukalt",
    "visitUpdated": "Visiit uuendati edukalt",
    "visitDeleted": "Visiit kustutati edukalt"
  },
  "studyResults": {
    "user": "Kasutaja",
    "department": "Osakond",
    "study": "Uuring",
    "date": "Kuupäev",
    "survey": "Küsitlus",
    "results": "Tulemused",
    "studyResults": "Uuringu tulemused",
    "surveyResults": "Küsitluse tulemused",
    "list": "Loend",
    "graph": "Graafik",
    "surveyStartDate": "Küsitluse algus",
    "surveyEndDate": "Küsitluse lõpp",
    "userResults": "Kasutaja tulemused",
    "question": "Küsimus",
    "questionType": "Küsimuse tüüp",
    "answer": "Vastus",
    "position": "Positsioon",
    "scaleAnswerFormat": "{value} — {meaning}"
  },
  "visitReport": {
    "consent": "Nõusolek",
    "viewConsent": "Vaata nõusolekut",
    "homeVisit": "Koduvisiit",
    "recomendationForTreatment": "Soovitused ravi, hoolduse, töö ja ambulatoorse järelevalve kohta",
    "anamnesis": "Anamnees",
    "answerType": "Vastuse tüüp",
    "contactPhone": "Kontakttelefon",
    "contactEmail": "Kontakt-e-post",
    "visitMadeBy": "Visiidi tegi",
    "homeVisitTime": "Koduvisiidi aeg",
    "visitForm": "Visiidi vorm",
    "viewHistory": "Vaata ajalugu",
    "patientsPrimaryHealthConcern": "Patsiendi peamine terviseprobleem",
    "conditionAssesmentInformation": "Seisundi hindamise teave",
    "bloodPressure": "Vererõhk",
    "measurement": "Mõõtmine",
    "BMI": "KMI",
    "diagnosis": "Diagnoos",
    "appliedMedicalTreatments": "Rakendatud ravimravi",
    "appliedTreatment": "Rakendatud ravi",
    "descriptionOfTestsConsultationPlans": "Testide/konsultatsiooniplaanide kirjeldus",
    "instrumentalTests": "Instrumentaalsed uuringud",
    "laboratoryTests": "Laboriuuringud",
    "appliedMedicalTreatment": "Rakendatud meditsiiniline ravi",
    "specialist": "Spetsialist",
    "status": "Staatus",
    "complaintData": "Kaebuse andmed",
    "pulse": "Pulss",
    "viewFullVisitForm": "Vaata täielikku visiidi vormi",
    "height": "Pikkus",
    "weight": "Kaal"
  },
  "institution": {
    "showArchived": "Kuva arhiveeritud asutused",
    "deleteInstitution": "Kustuta asutus",
    "deletedInstitution": "Asutus kustutatud",
    "restore": "Taasta",
    "restoredInstitution": "Asutus taastatud",
    "accessRevoked": "Teie asutus on eemaldatud. Olete välja logitud.",
    "confirms": {
      "deleteTitle": "Kustuta {name}?",
      "deleteText": "See peidab asutuse ja selle osakonnad haldurist ning tühistab kohe kogu personali juurdepääsu. Selle saab tagasi võtta, taastades asutuse.",
      "restoreTitle": "Taasta {name}?",
      "restoreText": "See muudab asutuse ja selle osakonnad taas nähtavaks ning taastab personali juurdepääsu."
    }
  },
  "department": {
    "deleteDepartment": "Kustuta osakond",
    "deletedDepartment": "Osakond kustutatud",
    "reassignTo": "Määra osakonnale",
    "noReassignmentTarget": "See on asutuse ainus osakond. Looge enne selle kustutamist teine osakond.",
    "showArchived": "Kuva arhiveeritud osakonnad",
    "restore": "Taasta",
    "restoredDepartment": "Osakond taastatud",
    "confirms": {
      "deleteTitle": "Kustuta {name}?",
      "deleteText": "Kõik selle osakonna kasutajad, protseduurid, õppematerjalid, uuringud ja seadmed määratakse allpool valitud osakonnale. Seda ei saa tagasi võtta.",
      "restoreTitle": "Taasta {name}?",
      "restoreText": "See muudab osakonna taas nähtavaks ja taastab personali juurdepääsu."
    }
  },
  "category": {
    "addCategory": "Lisa kategooria",
    "confirms": {
      "deleteTitle": "Kustutada {name}?",
      "deleteTextImmediate": "Sellel kategoorial pole protseduure ja selle saab kohe kustutada. Seda ei saa tagasi võtta.",
      "chooseReassignMode": "Sellel kategoorial on veel protseduure. Vali, kuidas need enne kustutamist ümber määrata.",
      "deleteTextAllAtOnce": "Vali kategooria, kuhu kõik protseduurid ümber tõstetakse. Seda ei saa tagasi võtta.",
      "deleteTextOneByOne": "Vaata allolevad protseduurid üle ja vali seejärel kategooria, kuhu need kõik ümber tõstetakse.",
      "affectedProcedures": "Protseduurid, mis liigutatakse",
      "stillHasProcedures": "Sellel kategoorial on veel protseduure. Palun vali sihtkategooria."
    },
    "deletedCategory": "Kategooria kustutatud",
    "editCategory": "Muuda kategooriat",
    "frequency": "Sagedus",
    "reassignAllAtOnce": "Määra kõik protseduurid korraga ümber",
    "reassignOneByOne": "Määra ümber ükshaaval",
    "reassignTo": "Määra ümber",
    "searchCategories": "Otsi kategooriaid",
    "updatedCategory": "Kategooria uuendatud"
  }
}
